import { APP_ROUTES } from './app-routes'

export function resolveSafeRedirectPath(redirectPath: string | undefined) {
  if (!redirectPath) return APP_ROUTES.chat
  if (!redirectPath.startsWith('/')) return APP_ROUTES.chat
  if (redirectPath.startsWith('//')) return APP_ROUTES.chat
  if (redirectPath === APP_ROUTES.auth.postSignin) return APP_ROUTES.chat
  if (redirectPath.startsWith(`${APP_ROUTES.auth.postSignin}?`)) {
    return APP_ROUTES.chat
  }
  return redirectPath
}
